import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=03f7090a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03f7090a')) {
      api.createRecord('03f7090a', component.options)
    } else {
      api.reload('03f7090a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=03f7090a&", function () {
      api.rerender('03f7090a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZNYJHRzh4j5o/JS/comp/childrenage.vue"
export default component.exports